// Generated from SVG to Code Figma Plugin

export const ProStudioWhite = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.53798 3.91894C6.98436 2.47255 9.32942 2.47255 10.7758 3.91894L20.3033 13.4464C21.7497 14.8928 21.7497 17.2379 20.3033 18.6843L17.9201 21.0675C17.5585 21.4291 16.9722 21.4291 16.6106 21.0675L3.15477 7.61161C2.79317 7.25001 2.79317 6.66374 3.15477 6.30215L5.53798 3.91894Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M5.79996 9.31394L8.15698 6.95692" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M14.5856 18.7426L16.9426 16.3856" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path
      d="M4.13751 15.1847C3.37707 15.946 2.94992 16.978 2.94992 18.0541V21.3H6.21915C7.29626 21.3 8.32923 20.872 9.0907 20.1102L20.4798 8.7165C21.8442 7.35155 21.8442 5.13914 20.4798 3.77417C19.1143 2.40805 16.8996 2.40842 15.5345 3.77501L4.13751 15.1847Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
